export default __webpack_public_path__ + "static/media/trello.4a998c52.png";